import { memo } from 'react'
import { ValueType, components } from 'react-select'
import styled from 'styled-components'

import { FlexDivRow } from 'components/layout/flex'
import Select from 'components/Select'
import { Body } from 'components/Text'
import { V3_DEPOSIT_OPTIONS } from 'constants/perpsV3'
import { SYNTH_ICONS } from 'utils/icons'

const AssetSelector = memo(
	({
		onSelectAsset,
		selectedValue,
	}: {
		onSelectAsset: (asset: ValueType<any>) => void
		selectedValue: { label: string; value: string } | undefined
	}) => {
		return (
			<StyledSelect
				variant="flat"
				menuWidth={'100%'}
				onChange={onSelectAsset}
				value={selectedValue}
				maxMenuHeight={140}
				formatOptionLabel={(option: { value: string; label: string }) => {
					const src = SYNTH_ICONS[option.value]
					return (
						<AssetOption>
							<img height="20px" width="20px" src={src} />
							<Body>{option.label}</Body>
						</AssetOption>
					)
				}}
				components={{
					Option: (option: any) => {
						const src = SYNTH_ICONS[option.data.value]
						const { Option } = components

						return (
							<Option {...option}>
								<AssetOption>
									<img height="20px" width="20px" src={src} />
									<Body>{option.data.label}</Body>
								</AssetOption>
							</Option>
						)
					},
				}}
				defaultValue={V3_DEPOSIT_OPTIONS[0]}
				options={V3_DEPOSIT_OPTIONS}
			/>
		)
	}
)

export default AssetSelector

const StyledSelect = styled(Select)`
	margin: 16px 0;
`

const AssetOption = styled(FlexDivRow)`
	justify-content: flex-start;
	align-items: center;
	gap: 8px;
`
